module.exports = __webpack_public_path__ + "img/de.e542e58e.svg";